/* !
 * jQuery case v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function($, FUNCTIONS){

	// タグ一覧取得
	const getJSONtag = () => {
		return $.getJSON('/ajax/case/tag.json');
	};
	const setTagList = () => {
		if($('.js-tagJsonList').length) {
			getJSONtag().done((item) => {
				let itemList = item.rt_bn_tag_list;
				let htmlBlock;
				for(let i = 0; i < itemList.length; i++) {
					htmlBlock = '<li class="pure-u-1-5 pure-u-md-1-2"><div class="mod-button03">'+
					`<a href="/case/tag/${itemList[i].cf_nt_url}/">`+
					`<span class="mod-button03-text"><span class="mod-button03-text-red">#</span><span>${itemList[i].cf_nt_name_d}</span></span>`+
					'<span class="mod-button03-bg"></span></a></div></li>';
					$('.js-tagJsonList').append(htmlBlock);
				}
			});
		}
	};

	// ＜case詳細＞
	const getJSONCaseList = () => {
		return $.getJSON('/ajax/case.json');
	};
	const randomPickup = () => {
		if ($('.js-randomPickup').length) {
			let thisID = FUNCTIONS.va.pathname.split('/')[2].replace(/\.html/, '');
			getJSONCaseList().then((data) => {
				if (data.rt_bn_case_list.length) {
					let jsonData = data.rt_bn_case_list;
					let numArr = [];
					let appendHTML = '';
					for (let i = 0; i < jsonData.length; i++) {
						numArr.push(Math.random());
					}
					let randArr = jsonData.sort((a, b) => {
						return numArr[jsonData.indexOf(a)] - numArr[jsonData.indexOf(b)];
					});
					let cnt = 0;
					for (let i = 0; i < randArr.length; i++) {
						if (randArr[i]._key !== thisID) {
							appendHTML += '<li class="pure-u-1-3 pure-u-md-1-2 space-u-40-child">' +
								`<a href="${randArr[i].rt_cf_n_href_case.href}" class="mod-box05 _tag"><div class="mod-box05-img"><figure>` +
								`<img src="/news/news_file/file/${randArr[i].cf_n_thum_img}" alt="${randArr[i].cf_n_thum_img_alt}"></figure></div>` +
								`<div class="mod-box05-text"><h3>${randArr[i].cf_n_title}</h3><p class="mt10">${randArr[i].cf_n_description}</p></div></a>`+
								'<div class="mod-box05-tags"><ul class="__inner">';
							if (randArr[i].cf_n_tags.length) {
								for (let j = 0; j < randArr[i].cf_n_tags.length; j++) {
									appendHTML += `<li><a href="/case/tag/${randArr[i].cf_n_tags[j]._key}/">` +
										`#${randArr[i].cf_n_tags[j].cf_nt_name_d}</a></li>`;
								}
							}
							appendHTML += '</ul></div></li>';
							cnt++;
							if (cnt === 3) {
								break;
							}
						}
					}
					$('.js-randomPickup').append(appendHTML);
					$('.mod-box05-text').matchHeight();
					$('.mod-box05-tags ul').matchHeight();
				}
			});
		}
	};

	// ========= ↑↑ FUNCTIONS ↑↑ ========================================================================== //

	setTagList();
	randomPickup();

})(window.jQuery, window.FUNCTIONS);
